// extracted by mini-css-extract-plugin
module.exports = {"btn":"SendSmsForm_btn__JlvOO","grid":"SendSmsForm_grid__njSCb","iconRoot":"SendSmsForm_iconRoot__adkBL"};